"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateSurveyMarketRequestToJSON = exports.UpdateSurveyMarketRequestFromJSONTyped = exports.UpdateSurveyMarketRequestFromJSON = exports.instanceOfUpdateSurveyMarketRequest = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the UpdateSurveyMarketRequest interface.
 */
function instanceOfUpdateSurveyMarketRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfUpdateSurveyMarketRequest = instanceOfUpdateSurveyMarketRequest;
function UpdateSurveyMarketRequestFromJSON(json) {
    return UpdateSurveyMarketRequestFromJSONTyped(json, false);
}
exports.UpdateSurveyMarketRequestFromJSON = UpdateSurveyMarketRequestFromJSON;
function UpdateSurveyMarketRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'surveyMarketId': !(0, runtime_1.exists)(json, 'survey_market_id') ? undefined : json['survey_market_id'],
        'market': !(0, runtime_1.exists)(json, 'market') ? undefined : json['market'],
    };
}
exports.UpdateSurveyMarketRequestFromJSONTyped = UpdateSurveyMarketRequestFromJSONTyped;
function UpdateSurveyMarketRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'survey_market_id': value.surveyMarketId,
        'market': value.market,
    };
}
exports.UpdateSurveyMarketRequestToJSON = UpdateSurveyMarketRequestToJSON;
